
const passwordElements = document.querySelectorAll('.js-form-type-password');
passwordElements.forEach(element => {
  const eyeIcon = document.createElement('span');
  eyeIcon.classList.add('icon--eye', 'toggle-password');
  eyeIcon.setAttribute('toggle', '#password-field');
  element.appendChild(eyeIcon);

  eyeIcon.addEventListener('click', function() {
    this.classList.toggle('eye--close');
    const input = element.querySelector('input');

    if (input.getAttribute('type') === 'password') {
      input.setAttribute('type', 'text');
    } else {
      input.setAttribute('type', 'password');
    }
  });
});